import Vue from 'vue'

import { de, enUS } from 'date-fns/locale'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import { format, formatRelative } from 'date-fns'

var defaultLocale = enUS

if (navigator.language.substr(0, 2).toLowerCase() == 'de') {
  defaultLocale = de
}

let datefns = {
  formatRelative(date) {
    date = this.anyToDate(date)
    return (date ? formatRelative(date, new Date(), {locale: defaultLocale}) : "-");
  },
  anyToDate(date) {
    if (typeof date == "string") {
      return new Date(date)
    }
    return date
  },
  formatRelativeWithTime(date) {
    if (! date) {
      return '-'
    }
    date = this.anyToDate(date)
    let diff = differenceInCalendarDays(date, new Date())
    if (diff >= 6 || diff < -6) {
      return format(date, 'P p', {locale: defaultLocale})
    }
    return this.formatRelative(date);
  },
  formatTime(date) {
    return format(date, 'p', {locale: defaultLocale})
  },
  formatTimeRelative(date) {
    date = this.anyToDate(date)
    let diff = differenceInCalendarDays(date, new Date())
    if (diff == 0) {
      return this.formatTime(date)
    }
    return this.formatRelativeWithTime(date)
  }
}
datefns.locale = defaultLocale;

Vue.prototype.$datefns = datefns

export default datefns
